import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllUsersSchedulingListAction,
  resetAllusersScheduleList,
  resetAllusersScheduleTotalCount,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../../redux/scheduling";
import { resetSession } from "../../../../redux/auth";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import { GetAllUsersSchedulingListPayloadType } from "../../../../commonTypes/schedulingTypes";
import AllUsersScheduleSorting from "../../../../components/Scheduling/ScheduleReports/AllUsersReports/AllUsersScheduleSorting";
import AllUsersScheduleCalendarView from "../../../../components/Scheduling/ScheduleReports/AllUsersReports/AllUsersScheduleCalendarView";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  totalCount: number;
  allusersScheduleList: any;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchResetAllusersScheduleTotalCount: () => void;
  dispatchResetAllusersScheduleList: () => void;
  dispatchGetAllUsersSchedulingList: (
    data: GetAllUsersSchedulingListPayloadType
  ) => void;
};
const AllUsersSchedule = ({
  token,
  fetching,
  message,
  error,
  statusCode,
  success,
  totalCount,
  allusersScheduleList,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchGetAllUsersSchedulingList,
  dispatchResetAllusersScheduleTotalCount,
  dispatchResetAllusersScheduleList,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [showData, setShowData] = useState(false);
  const [sortByUserName, setSortByUserName] = useState({
    name: "Recently Added First",
    value: "",
  });
  const [toggle, setToggle] = useState<boolean>(false);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [pendingHours, setPendingHours] = useState(false);
  useEffect(() => {
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetAllusersScheduleTotalCount();
    dispatchResetAllusersScheduleList();
  }, []);

  useEffect(() => {
    dispatchResetAllusersScheduleList();
    if (token && displayStartDate && displayEndDate) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        scheduleStatus: pendingHours ? 1 : 3,
      };
      dispatchGetAllUsersSchedulingList(finalData);
    }
  }, [sortByUserName?.name]);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmit = () => {
    setShowData(true);
    dispatchResetAllusersScheduleList();
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        scheduleStatus: pendingHours ? 1 : 3,
      };
      dispatchGetAllUsersSchedulingList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const fetchNewData = (status: boolean) => {
    setShowData(true);
    dispatchResetAllusersScheduleList();
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        scheduleStatus: status ? 1 : 3,
      };
      dispatchGetAllUsersSchedulingList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const handleChangeStatus = (e: any) => {
    let status = e?.target?.checked;
    fetchNewData(status);
    setPendingHours(!pendingHours);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="All User's Scheduling" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">
                All User's Scheduling List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } schedules found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex">
              {/* Future Use */}
              {/* <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                <SearchIcon/>
                            </span>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search"
                                //   onChange={(e) => handleSearch(e)}
                                style={{ paddingLeft: "45px" }}
                            /> */}
              <div className="ml-2">
                <AllUsersScheduleSorting
                  setSortByUserName={setSortByUserName}
                  sortByUserName={sortByUserName}
                />
              </div>
            </div>
          </div>
          {/*  */}
          <div>
            <div className="d-flex align-items-start">
              <div className="form-group ml-3">
                <label className="mb-1">Date</label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                  />
                </div>
              </div>
              <div className="ml-3" style={{ marginTop: "29px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  disabled={!startDate?.length || !endDate?.length || fetching}
                  onClick={handleSubmit}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          {!showData ? (
            <div className="mt-5">
              <EmptyListPage
                title="No Schedule Found!"
                text=""
                imageWidth="30%"
              />
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "15px",
                }}
              >
                <label className="switchs ml-3">
                  <input
                    type="checkbox"
                    checked={pendingHours}
                    onChange={(e) => handleChangeStatus(e)}
                  />
                  <span className="sliders rounds"></span>
                </label>
                <span style={{ fontWeight: "500" }}>Show me pending hours</span>
              </div>

              <AllUsersScheduleCalendarView
                pendingHours={pendingHours}
                data={allusersScheduleList}
                fetching={fetching}
                totalCount={totalCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
              />
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  fetching: state.scheduling.fetching,
  allusersScheduleList: state.scheduling.allusersScheduleList,
  totalCount: state.scheduling.allusersScheduleTotalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchResetAllusersScheduleList: () =>
    dispatch(resetAllusersScheduleList()),
  dispatchResetAllusersScheduleTotalCount: () =>
    dispatch(resetAllusersScheduleTotalCount()),
  dispatchGetAllUsersSchedulingList: (
    data: GetAllUsersSchedulingListPayloadType
  ) => dispatch(getAllUsersSchedulingListAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllUsersSchedule);
